const useAbortController = () => {
  const abortController = new AbortController();
  return { signal: abortController.signal };
};

export default useAbortController;
